import React from 'react';
import { Modal, Button, Row, Col, Icon, Divider } from 'antd';

export default class ErrorModal extends React.Component {
    constructor(props) { super(props); }
    render() {
        const { inError, errorHeader, errorSubHeader, errorDetail } = this.props;
        return ( <div>
            <Modal
                width={300}
                visible={inError}
                closable={false}
                footer={null}
                style={{
                    position: 'absolute',
                    transform: 'translate(-50%, -50%)',
                    top: '50%',
                    left: '50%',
                    width: '100%'
                }}
            >
                <Row type='flex' justify='center' align='top'>
                    <Col>
                        <Divider style={{ fontSize: '17px', fontWeight: 'bold', margin: '0px 0px 20px 0px' }}>
                            {errorHeader}
                        </Divider>
                        <h3>
                            {`${errorSubHeader}:`}
                        </h3>
                        <div style={{ fontStyle: 'italic' }}>
                            {errorDetail}
                        </div>
                    </Col>
                </Row>
                <Row type='flex' justify='center' align='top' style={{ margin: '20px 0px' }}>
                    <Col>
                        <Icon type='close-circle-o' style={{ fontSize: '70px', color: 'red' }} />
                    </Col>
                </Row>
                <Row type='flex' justify='center' align='middle' gutter={16}>
                    <Col>
                        <Button
                            size='small'
                            icon='home'
                            style={{ width: '100px', borderRadius: '20px 4px 4px 20px' }}
                            onClick={() => window.location.replace('/home')}
                        >
                            {'Home'}
                        </Button>
                    </Col>
                    <Col>
                        <Button
                            size='small'
                            icon='reload'
                            style={{ width: '100px', borderRadius: '4px 20px 20px 4px' }}
                            onClick={() => window.location.reload()}
                        >
                            {'Retry'}
                        </Button>
                    </Col>
                </Row>
            </Modal>
        </div> );
    }
}
